import Select, { components, type FormatOptionLabelMeta } from "react-select";
import { colors } from "../../../../colors";
import { BaseOption, StaticSelectProps, madfarmDefaultSelectTheme } from "../Select.types";

export function MadfarmStaticSelect(props: StaticSelectProps) {
  const CustomInput = (props: any) => {
    return <components.Input {...props} autoComplete="off" />;
  };

  const CustomOption = (optionProps: any) => {
    const { data, isFocused, isSelected } = optionProps;
    return (
      <components.Option {...optionProps}>
        <div className="text-left w-full">
          <div>{data.label}</div>
          {data.description && (
            <div
              className="text-sm font-normal"
              style={{ color: isFocused || isSelected ? colors.white : colors.neutral[500] }}
            >
              {data.description}
            </div>
          )}
        </div>
      </components.Option>
    );
  };

  return (
    <div className="w-full flex flex-col gap-[4px]">
      {props.label && <span className='text-left text-label-md font-semibold text-brandPrimary-800'>{props.label}{props.required && <span className="text-red-500"> *</span>}</span>}
      <Select
        //@ts-ignore
        styles={madfarmDefaultSelectTheme(props.error, props.customZIndex)}
        options={props.disabledOptions ? props.options.filter((option) => !props.disabledOptions?.includes(option)) : props.options}
        components={{ Input: CustomInput, Option: CustomOption }}
        id="madfarm-async-select"
        name="non_autofill_field_1"
        //@ts-ignore
        defaultValue={props.defaultValue}
        //@ts-ignore
        value={props.value === null || props.value === undefined ? null : props.options?.find(opt => opt.value === props.value)}
        onChange={(e) => {
          props.onChange && props.onChange(e as string | string[] | null)
        }}
        formatOptionLabel={(option: BaseOption, formatOptionLabelMeta: FormatOptionLabelMeta<BaseOption>) => {
          const isInMenu = formatOptionLabelMeta.context === "menu";

          if (isInMenu) {
            return null;
          }

          return (
            <div>
              <div>{option.label}</div>
              {option.description && (
                <div className="text-sm font-normal text-subtle">
                  {option.description.length > 30 ? option.description.substring(0, 40).concat("...") : option.description}
                </div>
              )}
            </div>
          );
        }}
        menuPortalTarget={props.menuPortalTargetIsNotBody ? undefined : document.body}
        menuPlacement="auto"
        isClearable={props.isClearable}
        isMulti={props.isMulti}
        isDisabled={props.disabled}
        noOptionsMessage={() => <span className="text-xs block w-full text-left">{props.noOptionsMessage}</span>}
        placeholder={props.placeholder}
      />
      {props.error && <span className="text-sm font-semibold text-red-500 text-left">{props.errorLabel}</span>}
    </div>
  );
};
